import * as React from "react";

const Badges = ({ badges }) => {
  if (!badges || badges.length === 0) {
    return null;
  }

  return (
    <div className="badges">
      {badges.map((badge) => (
        <span
          key={badge.label}
          className="badge"
          style={{
            "--badge-bg": badge.backgroundColor,
            "--badge-opacity": `${badge.opacity ?? 100}%`,
            "--badge-color": badge.textColor,
          }}
        >
          {badge.label}
        </span>
      ))}
    </div>
  );
};

export default Badges;
